import mutations from "./mutations";
import * as queries from "./queries";

export const gqlBenefits = {
  queries,
  mutations
};

export default {
  queries,
  mutations
};
